export const SPECIALTY_OPTIONS = [
  { db: "Cardiology", label: "Cardiology", inputs: ["Cardiology"] },
  { db: "Neurology", label: "Neurology", inputs: ["Neurology"] },
  { db: "Orthopedics", label: "Orthopedics", inputs: ["Orthopedic", "Orthopedics"] },
  {
    db: "Gastroenterology",
    label: "Gastroenterology",
    inputs: ["Gastroenterology"],
  },
  { db: "Psychology", label: "Psychology", inputs: ["Psychology"] },
  { db: "Psychiatry", label: "Psychiatry", inputs: ["Psychiatry"] },
  {
    db: "PMR",
    label: "Physical Medicine and Rehabilitation (PM&R)",
    inputs: [
      "Physical Medicine Rehab",
      "Physical Medicine and Rehab",
      "Physical Medicine and Rehabilitation",
      "PM&R",
      "PMR",
    ],
  },
  { db: "Nephrology", label: "Nephrology", inputs: ["Nephrology"] },
  { db: "Urology", label: "Urology", inputs: ["Urology"] },
  {
    db: "Hematology Oncology",
    label: "Hematology/Oncology",
    inputs: [
      "Hematology/Oncology",
      "Hematology Oncology",
      "Heme/Onc",
      "Heme Onc",
    ],
  },
  { db: "General Surgery", label: "General Surgery", inputs: ["General Surgery"] },
  { db: "Dermatology", label: "Dermatology", inputs: ["Dermatology"] },
  { db: "Podiatry", label: "Podiatry", inputs: ["Podiatry"] },
  {
    db: "Otolaryngology",
    label: "Ear, Nose, and Throat (ENT)",
    inputs: [
      "Ear, Nose, and Throat (ENT)",
      "Ear, Nose, and Throat",
      "Ear Nose and Throat",
      "ENT",
      "Otolaryngology",
    ],
  },
  {
    db: "VA Tech Sprint",
    label: "Primary Care",
    inputs: ["Primary Care", "VA Tech Sprint"],
  },
];

export const SAN_MATEO_SPECIALTY_OPTIONS = [
  {
    db: "SM Primary Care",
    label: "Primary Care",
    inputs: ["SM Primary Care", "San Mateo Primary Care"],
  },
  {
    db: "SM OB",
    label: "Obstetrics",
    inputs: ["SM OB", "San Mateo OB", "San Mateo Obstetrics"],
  },
  {
    db: "SM ED",
    label: "Emergency Department",
    inputs: ["SM ED", "San Mateo ED", "San Mateo Emergency Department"],
  },
  {
    db: "SM Psychiatric",
    label: "Psychiatric",
    inputs: ["SM Psychiatric", "San Mateo Psychiatric"],
  },
];

const ALL_SPECIALTY_OPTIONS = [...SPECIALTY_OPTIONS, ...SAN_MATEO_SPECIALTY_OPTIONS];

const normalizeInput = (value) => value.replace(/\s+/g, " ").trim().toLowerCase();

const buildInputToDbMap = (options) =>
  options.reduce((acc, entry) => {
    const values = [entry.db, ...(entry.inputs || [])];
    values.forEach((candidate) => {
      acc.set(normalizeInput(candidate), entry.db);
    });
    return acc;
  }, new Map());

const buildDbToLabelMap = (options) =>
  options.reduce((acc, entry) => {
    acc.set(entry.db, entry.label);
    return acc;
  }, new Map());

export const resolveSpecialtyToDbValue = (
  rawSpecialty,
  specialtyOptions = ALL_SPECIALTY_OPTIONS
) => {
  if (typeof rawSpecialty !== "string") return null;
  const normalized = normalizeInput(rawSpecialty);
  if (!normalized) return null;
  const specialtyInputToDbMap = buildInputToDbMap(specialtyOptions);
  return specialtyInputToDbMap.get(normalized) || null;
};

export const getSpecialtyLabelFromDbValue = (
  dbSpecialty,
  specialtyOptions = ALL_SPECIALTY_OPTIONS
) => {
  if (typeof dbSpecialty !== "string") {
    return "Primary Care";
  }
  const specialtyDbToLabelMap = buildDbToLabelMap(specialtyOptions);
  return specialtyDbToLabelMap.get(dbSpecialty) || dbSpecialty;
};
